import { inject, injectable } from "inversify";
import { GuidSelectModel, ICPLPurchaseAccountInformationClient } from "./api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

export interface IPurchaseAccountInformationService {
  getSelectModels(): Promise<GuidSelectModel[]>;
}

@injectable()
export class PurchaseAccountInformationService implements IPurchaseAccountInformationService {
  @inject(SERVICE_TYPES.CPLPurchaseAccountInformationClient)
  purchaseAccountInformationClient!: ICPLPurchaseAccountInformationClient;

  async getSelectModels(): Promise<GuidSelectModel[]> {
    return this.purchaseAccountInformationClient.getSelectModels();
  }
}
